module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-401k-16d1000de57544c33f4a10fac217c342.svg";